import { useEffect, useState } from 'react';

import type { Placement } from 'components/Dropdown/Dropdown';

export function useDropdownPlacement(
  triggerRef: React.RefObject<HTMLElement>,
  dropdownHeight: number,
  preferredSide: 'left' | 'right' = 'left'
) {
  const [placement, setPlacement] = useState<Placement>(('on-bottom-' + preferredSide) as Placement);

  useEffect(() => {
    if (!triggerRef.current) {
      return;
    }

    const { top, bottom } = triggerRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - bottom;
    const spaceAbove = top;

    if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
      setPlacement(`on-bottom-${preferredSide}`);
    } else {
      setPlacement(`on-top-${preferredSide}`);
    }
  }, [triggerRef, dropdownHeight, preferredSide]);

  return placement;
}
